"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAuthService = void 0;
const FirebaseAuthService_1 = require("./services/FirebaseAuthService");
Object.defineProperty(exports, "FirebaseAuthService", { enumerable: true, get: function () { return FirebaseAuthService_1.FirebaseAuthService; } });
//# sourceMappingURL=index.js.map